import React, {
    Component,
} from 'react';

import PropTypes from 'prop-types';

import {
    heroBackground,
    heroMobileBackground,
} from 'wanderu-assets';
import DownloadIcons from 'wanderu-component-download-icons';
import {
    BranchLink,
    ChikuHeroDeskTop,
    Image,
    PageSection,
    Typography,
} from 'wanderu-components';
import { theme } from 'wanderu-css';
import {
    localize,
} from 'wanderu-i18n';
import SearchWidget from 'wanderu-widget';

import styles from './HeroHeader.scss';

const VERTICAL_DOWN_SCROLL_TRIGGER = 510;
const VERTICAL_UP_SCROLL_TRIGGER = 430;
const DESKTOP_VERTICAL_DOWN_SCROLL_TRIGGER = 475;
const DESKTOP_VERTICAL_UP_SCROLL_TRIGGER = 371;

class HeroHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showStickyWidget: false,
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.detectScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.detectScroll);
    }

    detectScroll = () => {
        const { showStickyWidget } = this.state;
        const isDesktop = window.matchMedia(theme.breakpointsUp('lg')).matches;

        const downTrigger = isDesktop
            ? DESKTOP_VERTICAL_DOWN_SCROLL_TRIGGER
            : VERTICAL_DOWN_SCROLL_TRIGGER;
        const upTrigger = isDesktop
            ? DESKTOP_VERTICAL_UP_SCROLL_TRIGGER
            : VERTICAL_UP_SCROLL_TRIGGER;

        if (window.scrollY > downTrigger && !showStickyWidget) {
            return this.setState(() => ({ showStickyWidget: true }));
        } if (window.scrollY <= upTrigger && showStickyWidget) {
            return this.setState(() => ({ showStickyWidget: false }));
        }

        return undefined;
    };

    render() {
        const {
            children,
            className,
            isHome,
            showAppDownloadCTA,
            t,
            title,
            widgetProps,
        } = this.props;
        const {
            showStickyWidget,
        } = this.state;

        return (
            <>
                <picture className={styles.imageContainer}>
                    <source
                        media={theme.breakpointsUp('md')}
                        srcSet={heroBackground}
                    />
                    <Image
                        alt=""
                        className={styles.heroImage}
                        height={314}
                        src={heroMobileBackground}
                        width={751}
                    />
                </picture>

                <PageSection
                    aria-labelledby="hero-header-title"
                    className={className}
                    layoutClassName={styles.layout}
                >
                    <div className={styles.contentContainer}>
                        <ChikuHeroDeskTop className={styles.chikuHero} />
                        <div className={styles.widgetContainer}>
                            <div className={styles.titleContainer}>
                                <div>
                                    <Typography
                                        className={styles.title}
                                        id="hero-header-title"
                                        variant="h1"
                                    >
                                        {title}
                                    </Typography>
                                    {!isHome && <Typography>{t('baseApp:search-box-subheader')}</Typography>}
                                </div>
                                <div className={styles.chikuSpacer}></div>
                            </div>
                            <SearchWidget
                                sticky={showStickyWidget}
                                stickyClassName={styles.sticky}
                                title={title}
                                {...widgetProps}
                            />
                            {showAppDownloadCTA && (
                                <>
                                    <DownloadIcons />
                                    <BranchLink className={styles.downloadContainer}>
                                        <Typography
                                            className={styles.downloadCTA}
                                            variant="caption"
                                        >
                                            {t('baseApp:available-on-ios-and-android')}
                                        </Typography>
                                    </BranchLink>
                                </>
                            )}
                        </div>
                        {children}
                    </div>
                </PageSection>
            </>
        );
    }
}

HeroHeader.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isHome: PropTypes.bool,
    showAppDownloadCTA: PropTypes.bool,
    t: PropTypes.func,
    title: PropTypes.string.isRequired,
    widgetProps: PropTypes.shape({
        defaultDestinationInput: PropTypes.string,
        defaultDestinationPlaceId: PropTypes.string,
        defaultOriginInput: PropTypes.string,
        defaultOriginPlaceId: PropTypes.string,
        departDate: PropTypes.string,
        queries: PropTypes.object,
        title: PropTypes.string,
    }),
};
HeroHeader.defaultProps = {
    className: '',
    showAppDownloadCTA: true,
};

export {
    HeroHeader,
};
export default localize(HeroHeader, ['t']);
